<template>
  <router-link to="/" class="italy is-block is-relative">
    <div class="columns">
      <div class="column is-9 italy__content">
        <div class="has-text-centered-mobile">
          <p class="has-text-centered-mobile title has-text-white is-inline-block is-size-5-mobile is-size-3-tablet has-text-weight-bold is-uppercase u-pl15 u-pr15 p-3">15% di sconto su tutti i buoni vacanza!*</p>
          <br />
          <p class="italy__subtitle has-background-white has-text-dark pt-1 pb-1 pr-2 pl-2 is-size-6 is-size-5-tablet has-text-weight-normal is-inline-block">
            Solo oggi! Codice promozionale: <strong>PIRATI</strong>
            <small class="has-text-grey-light is-size-7 is-block">*Deals sono esclusi, fino ad esaurimento scorte.</small>
          </p>
        </div>
      </div>
    </div>
    <p class="has-text-right-tablet has-text-centered">
      <b-button tag="router-link" to="/" type="is-primary" class="mb-5 italy__button has-text-weight-bold">
        Risparmiare ora
      </b-button>
    </p>
  </router-link>
</template>

<script>
export default {
  name: 'Italy',

  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
//

.italy {
  background-color: #ccc;
  background-image: url('https://assets.urlaubsgutschein.kaufen/i/crop?width=768&height=473&gravity=smart&quality=50&interlace=true&type=auto&file=whitelabel/_assets/images/campaigns/italy.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  background-position: center bottom;

  .title {
    margin-bottom: 0.75rem;
    background-color: #1b7d9f;
    margin-top: 2rem;
  }

  @media screen and (min-width: 769px) {
    background-image: url('https://assets.urlaubsgutschein.kaufen/i/crop?width=1024&height=400&gravity=smart&quality=50&interlace=true&type=auto&file=whitelabel/_assets/images/campaigns/italy.jpg');

    .title {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 1024px) {
    background-image: url('https://assets.urlaubsgutschein.kaufen/i/crop?width=950&height=700&gravity=smart&quality=50&interlace=true&type=auto&file=whitelabel/_assets/images/campaigns/italy.jpg');
  }
  @media screen and (min-width: 1216px) {
    background-image: url('https://assets.urlaubsgutschein.kaufen/i/crop?width=1300&height=500&gravity=smart&quality=50&interlace=true&type=auto&file=whitelabel/_assets/images/campaigns/italy.jpg');
  }
}

.italy__subtitle {
}

.italy__button {
  @media screen and (min-width: 769px) {
    margin-right: 2rem;
  }
}

.italy__content {
  @media screen and (min-width: 769px) {
    margin-top: 2rem;
    margin-left: 2rem;
  }
}

@media screen and (min-width: 1024px) {
}

@media screen and (min-width: 1216px) {
}
</style>
